/* ===== JR-SAVED-0902b : Saved Homes / Saved Searches / Account journey ======
   Backed by the Shopify App Proxy at /apps/saved -> jasjeet-idx Worker + KV.
   No signing secret and no identity token ever reaches the browser: Shopify
   signs logged_in_customer_id server-side on every proxied request.

   Header pattern (desktop):  [ ♥ Saved (n) ]  [ Sign in ]  ->  [ ♥ (n) ] [ JS ]
   Every surface opened from the header is light (see jr-account-journey.css).
   ========================================================================= */
(function () {
  if (window.__JRSAVED) return; window.__JRSAVED = 1;
  var API = '/apps/saved';
  var ACCOUNT = '/pages/my-account';
  var SEARCH = '/pages/property-search';
  var S = { ready: false, anon: window.JR_CUSTOMER !== true, homes: [], searches: [], hidden: [], prefs: {}, profile: {} };

  /* ---------- utils ---------- */
  function api(path, opts) {
    var o = opts || {}; o.credentials = 'same-origin'; o.cache = 'no-store';
    return fetch(API + path, o).then(function (r) {
      return r.json().catch(function () { return { ok: false }; });
    }).catch(function () { return { ok: false }; });
  }
  function post(path, body) { return api(path, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) }); }
  function track(n, p) { try { if (window.jrxTrack) window.jrxTrack(n, p || {}); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
  function initials() {
    var n = (S.profile && S.profile.name) || (window.JR_CUSTOMER_NAME || '') || '';
    n = String(n).trim();
    if (!n) return 'ME';
    var p = n.split(/\s+/);
    return ((p[0] || '')[0] || '').toUpperCase() + ((p[1] || '')[0] || '').toUpperCase() || 'ME';
  }
  function firstName() { var n = (S.profile && S.profile.name) || window.JR_CUSTOMER_NAME || ''; return String(n).trim().split(/\s+/)[0] || 'there'; }
  function cssReady() {
    if (document.getElementById('jr-account-journey-css')) return;
    var me = document.querySelector('script[src*="jr-account-journey.js"]');
    var l = document.createElement('link'); l.id = 'jr-account-journey-css'; l.rel = 'stylesheet';
    l.href = me ? me.getAttribute('src').replace(/jr-account-journey\.js.*$/, 'jr-account-journey.css') : '/cdn/shop/files/jr-account-journey.css';
    document.head.appendChild(l);
  }

  var ICO = {
    heart: '<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.5-7-9.2A4 4 0 0 1 12 8a4 4 0 0 1 7 2.8C19 15.5 12 20 12 20z"/></svg>',
    bell: '<svg viewBox="0 0 24 24"><path d="M6 9a6 6 0 0 1 12 0c0 4 1.5 5.5 1.5 5.5h-15S6 13 6 9z"/><path d="M10 18a2 2 0 0 0 4 0"/></svg>',
    search: '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/></svg>',
    user: '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.4"/><path d="M4.8 19.5a7.2 7.2 0 0 1 14.4 0"/></svg>',
    hide: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.4"/><path d="m6 18 12-12"/></svg>',
    home: '<svg viewBox="0 0 24 24"><path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 10v9.5h13V10"/></svg>',
    out: '<svg viewBox="0 0 24 24"><path d="M13.5 4.5H7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h6.5"/><path d="m16.5 8.5 3.5 3.5-3.5 3.5"/><path d="M20 12h-9.2"/></svg>',
    chev: '<svg viewBox="0 0 24 24"><path d="m9 6 6 6-6 6"/></svg>',
    check: '<svg viewBox="0 0 24 24"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    lock: '<svg viewBox="0 0 24 24"><rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></svg>',
    bed: '<svg viewBox="0 0 24 24"><path d="M3 18V8M3 14h18v4M7 11h5a2 2 0 0 1 2 2v1M21 18v-5a2 2 0 0 0-2-2h-5"/></svg>',
    bath: '<svg viewBox="0 0 24 24"><path d="M4 13h16v2a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-2zM6 13V6a2 2 0 0 1 4 0"/></svg>',
    sqft: '<svg viewBox="0 0 24 24"><path d="M4 4h16v16H4zM4 9h5V4M15 20v-5h5"/></svg>'
  };

  /* ---------- toast ---------- */
  function toast(msg, linkText, href) {
    var old = document.querySelector('.jrsv-toast'); if (old && old.parentNode) old.parentNode.removeChild(old);
    var t = el('<div class="jrsv-toast" role="status">' + ICO.check + '<span>' + esc(msg) + '</span>' + (href ? '<a href="' + esc(href) + '">' + esc(linkText) + '</a>' : '') + '</div>');
    document.body.appendChild(t);
    setTimeout(function () { t.style.opacity = '0'; t.style.transition = 'opacity .3s'; }, 3200);
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 3600);
  }

  /* ---------- sign-in gate (light modal) ---------- */
  function loginUrl(back) { return (window.JR_LOGIN_PATH || '/customer_authentication/login?return_to=') + encodeURIComponent(back || ACCOUNT); }
  function login(intent, backTo, ctx) {
    try { sessionStorage.setItem('jrsv_intent', JSON.stringify(intent || null)); } catch (e) {}
    authGate(backTo || (location.pathname + location.search + location.hash), ctx || (intent && intent.t) || 'account');
  }
  var GATE = {
    home: ['Save this home', 'Keep every home you love in one place', 'Log in or create a free account and this home is saved to your list.'],
    hide: ['Hide this home', 'Tidy up your search', 'Log in or create a free account to keep hidden listings out of your results.'],
    search: ['Save this search', 'Let the right homes find you', 'Log in or create a free account to get new matches by email.'],
    account: ['Your account', 'Your Calgary home search, organised', 'Saved homes, saved searches and alerts, in one place on every device.']
  };
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function authGate(back, ctx) {
    var old = document.querySelector('.jrsv-gate'); if (old && old.parentNode) old.parentNode.removeChild(old);
    var g = GATE[ctx] || GATE.account;
    var social = window.JR_SOCIAL || [];
    var socialHtml = '';
    if (social.indexOf('google') > -1) socialHtml += '<button type="button" class="jrsv-gate__alt" data-gate="go"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#4285F4" d="M21.6 12.23c0-.68-.06-1.33-.17-1.96H12v3.7h5.38a4.6 4.6 0 0 1-2 3.02v2.5h3.24c1.9-1.75 2.98-4.32 2.98-7.26z"/><path fill="#34A853" d="M12 22c2.7 0 4.96-.9 6.62-2.43l-3.24-2.5c-.9.6-2.04.96-3.38.96-2.6 0-4.8-1.75-5.58-4.1H3.07v2.58A10 10 0 0 0 12 22z"/><path fill="#FBBC05" d="M6.42 13.93A6 6 0 0 1 6.1 12c0-.67.12-1.32.32-1.93V7.49H3.07A10 10 0 0 0 2 12c0 1.61.39 3.14 1.07 4.51l3.35-2.58z"/><path fill="#EA4335" d="M12 5.97c1.47 0 2.78.5 3.82 1.5l2.86-2.86A10 10 0 0 0 12 2a10 10 0 0 0-8.93 5.49l3.35 2.58C7.2 7.72 9.4 5.97 12 5.97z"/></svg><span>Continue with Google</span></button>';
    if (social.indexOf('facebook') > -1) socialHtml += '<button type="button" class="jrsv-gate__alt" data-gate="go"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#1877F2" d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.45 2.89h-2.33v6.99A10 10 0 0 0 22 12z"/></svg><span>Continue with Facebook</span></button>';
    var ov = el('<div class="jrsv-gate">'
      + '<div class="jrsv-gate__box" role="dialog" aria-modal="true" aria-labelledby="jrsvGateTitle">'
      + '<div class="jrsv-gate__hd"><h2 id="jrsvGateTitle">Sign up or Log in</h2><button type="button" class="jrsv-gate__x" data-gate="no" aria-label="Close">&times;</button></div>'
      + '<p class="jrsv-gate__lede">' + esc(g[2]) + '</p>'
      + '<form class="jrsv-gate__form" novalidate>'
      + '<label class="jrsv-gate__lbl" for="jrsvEmail">Email</label>'
      + '<input id="jrsvEmail" class="jrsv-gate__in" type="email" name="email" placeholder="Enter email address" autocomplete="email" inputmode="email" autocapitalize="none" spellcheck="false">'
      + '<p class="jrsv-gate__err" hidden><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.2v.3"/></svg>Please enter a valid email address.</p>'
      + '<button type="submit" class="jra-btn jra-btn--block jrsv-gate__go">Submit</button>'
      + '</form>'
      + (socialHtml ? '<div class="jrsv-gate__or"><span>OR</span></div><div class="jrsv-gate__alts">' + socialHtml + '</div>' : '')
      + '<p class="jrsv-gate__legal">I accept Jasjeet Singh\'s <a href="/policies/terms-of-service" target="_blank" rel="noopener">Terms of Use</a> and <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.</p>'
      + '<p class="jrsv-gate__secure">' + ICO.lock + 'No password. We email you a one-time code.</p>'
      + '</div></div>');
    function close() { if (ov.parentNode) ov.parentNode.removeChild(ov); document.removeEventListener('keydown', onKey, false); }
    function onKey(ev) { if (ev.key === 'Escape') close(); }
    function go(hint) { track('signin_start', { ctx: ctx, method: hint ? 'email' : 'social' }); location.href = loginUrl(back) + (hint ? '&login_hint=' + encodeURIComponent(hint) : ''); }
    var form = ov.querySelector('.jrsv-gate__form'), input = ov.querySelector('#jrsvEmail'), err = ov.querySelector('.jrsv-gate__err');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = (input.value || '').trim();
      if (!EMAIL_RE.test(v)) { err.hidden = false; input.classList.add('is-bad'); input.focus(); return; }
      err.hidden = true; input.classList.remove('is-bad');
      form.querySelector('.jrsv-gate__go').textContent = 'One moment…';
      go(v);
    }, false);
    input.addEventListener('input', function () { if (!err.hidden && EMAIL_RE.test(input.value.trim())) { err.hidden = true; input.classList.remove('is-bad'); } }, false);
    ov.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-gate]') : null;
      if (t && t.getAttribute('data-gate') === 'go') { go(''); return; }
      if (e.target === ov || (t && t.getAttribute('data-gate') === 'no')) close();
    }, false);
    document.addEventListener('keydown', onKey, false);
    document.body.appendChild(ov);
    track('signin_gate', { ctx: ctx });
    setTimeout(function () { try { input.focus(); } catch (e) {} }, 60);
  }

  /* ---------- data ---------- */
  function load() {
    return api('?_=' + Date.now()).then(function (d) {
      S.ready = true;
      S.anon = (d.anon === true) || d.ok !== true;
      S.homes = d.homes || []; S.searches = d.searches || [];
      S.hidden = d.hidden || []; S.prefs = d.prefs || {}; S.profile = d.profile || {};
      paint(); renderDash(); resume(); return S;
    });
  }
  function ensure(fn) { if (S.ready) return fn(); load().then(fn); }
  function isSaved(mls) { for (var i = 0; i < S.homes.length; i++) if (S.homes[i].mls === mls) return true; return false; }

  function saveHome(payload) {
    return post('/home', payload).then(function (d) {
      if (d && d.ok) {
        if (d.saved) { S.homes.unshift(Object.assign({ at: new Date().toISOString() }, payload)); track('saved_home', { mls: payload.mls, address: payload.address, price: payload.price }); toast('Saved to your homes', 'View saved', ACCOUNT + '#homes'); }
        else { S.homes = S.homes.filter(function (h) { return h.mls !== payload.mls; }); toast('Removed from saved homes'); }
        paint();
      } else if (d && d.anon) { login({ t: 'home', d: payload }); }
      else { toast('Could not save that just now'); }
      return d;
    });
  }
  function saveSearch(payload) {
    return post('/search', payload).then(function (d) {
      if (d && d.ok && d.search) {
        S.searches = S.searches.filter(function (x) { return x.id !== d.search.id; });
        S.searches.unshift(d.search);
        track('saved_search', { name: d.search.name, query: d.search.query, alerts: d.search.freq });
        toast('Search saved. Alerts: ' + d.search.freq, 'Manage', ACCOUNT + '#searches');
        paint();
      } else if (d && d.anon) { login({ t: 'search', d: payload }); }
      else { toast('Could not save that search'); }
      return d;
    });
  }
  function delHome(mls) { return api('/home?mls=' + encodeURIComponent(mls), { method: 'DELETE' }).then(function () { S.homes = S.homes.filter(function (h) { return h.mls !== mls; }); paint(); }); }
  function delSearch(id) { return api('/search?id=' + encodeURIComponent(id), { method: 'DELETE' }).then(function () { S.searches = S.searches.filter(function (x) { return x.id !== id; }); paint(); }); }
  function hideHome(payload) {
    return post('/hidden', payload).then(function (d) {
      if (d && d.ok) { return load(); }
      if (d && d.anon) login({ t: 'hide', d: payload });
      return d;
    });
  }
  function resume() {
    var raw = null; try { raw = sessionStorage.getItem('jrsv_intent'); } catch (e) {}
    if (!raw) return;
    try { sessionStorage.removeItem('jrsv_intent'); } catch (e) {}
    if (S.anon) return;
    var it = null; try { it = JSON.parse(raw); } catch (e) {}
    if (!it) return;
    if (it.t === 'home') saveHome(it.d);
    else if (it.t === 'hide') hideHome(it.d);
    else if (it.t === 'search') saveSearch(it.d);
  }

  /* ---------- shared row/card renderers ---------- */
  function specs(h) {
    var b = [];
    if (h.beds) b.push('<span>' + ICO.bed + esc(h.beds) + ' bd</span>');
    if (h.baths) b.push('<span>' + ICO.bath + esc(h.baths) + ' ba</span>');
    if (h.sqft) b.push('<span>' + ICO.sqft + esc(Number(h.sqft).toLocaleString()) + ' sqft</span>');
    return b.join('');
  }
  function qSummary(q) {
    try {
      var p = new URLSearchParams(q); var bits = [];
      if (p.get('cities')) bits.push(p.get('cities'));
      else if (p.get('q')) bits.push(p.get('q'));
      if (p.get('beds') && p.get('beds') !== '0') bits.push(p.get('beds') + '+ bed');
      if (p.get('baths') && p.get('baths') !== '0') bits.push(p.get('baths') + '+ bath');
      var mn = parseInt(p.get('min') || '0', 10), mx = parseInt(p.get('max') || '0', 10);
      if (mn > 0) bits.push('from $' + mn.toLocaleString());
      if (mx > 0 && mx < 90000000) bits.push('to $' + mx.toLocaleString());
      if (p.get('openhouse')) bits.push('open houses');
      return bits.length ? bits : ['All residential'];
    } catch (e) { return ['Saved search']; }
  }

  /* ---------- header: desktop controls ---------- */
  var openSurface = null;
  function closeSurfaces() {
    [].forEach.call(document.querySelectorAll('.jrsv-pop.is-open,.jrsv-menu.is-open'), function (m) { m.classList.remove('is-open'); });
    [].forEach.call(document.querySelectorAll('.jrsv-item [aria-expanded="true"]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
    openSurface = null;
  }
  function toggleSurface(btn, panel) {
    var on = panel.classList.contains('is-open');
    closeSurfaces();
    if (!on) { panel.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); openSurface = panel; }
  }
  function buildHeader() {
    var nav = document.querySelector('#ghNav'); if (!nav) return;
    if (nav.querySelector('.jrsv-item')) return;
    var anchor = nav.querySelector('.gh-cta');
    var ins = function (node) { if (anchor && anchor.parentNode === nav) nav.insertBefore(node, anchor); else nav.appendChild(node); };

    var saved = el('<li class="gh-item jrsv-item jrsv-item--saved" data-jrsv="saved">'
      + '<a class="gh-link jrsv-link" href="' + ACCOUNT + '#homes" aria-haspopup="dialog" aria-expanded="false" aria-label="Saved homes and searches"><span class="jrsv-ico">' + ICO.heart + '<span class="jrsv-count"></span></span><span class="jrsv-label">Saved</span></a>'
      + '<div class="jrsv-pop" role="dialog" aria-label="Saved"></div></li>');
    var acct = el('<li class="gh-item jrsv-item jrsv-item--acct" data-jrsv="account">'
      + '<a class="gh-link jrsv-link" href="' + ACCOUNT + '"><span class="jrsv-ico">' + ICO.user + '</span><span class="jrsv-label">Sign in</span></a>'
      + '<button type="button" class="jrsv-avatar" aria-haspopup="menu" aria-expanded="false" aria-label="Your account">ME</button>'
      + '<div class="jrsv-menu" role="menu" aria-label="Your account"></div></li>');
    ins(saved); ins(acct);

    saved.querySelector('.jrsv-link').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var a = this;
      ensure(function () {
        if (S.anon) { closeSurfaces(); login(null, ACCOUNT + '#homes', 'account'); return; }
        paintPop(); toggleSurface(a, saved.querySelector('.jrsv-pop'));
      });
    }, false);
    acct.querySelector('.jrsv-link').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      ensure(function () { if (S.anon) { login(null, ACCOUNT, 'account'); return; } location.href = ACCOUNT; });
    }, false);
    acct.querySelector('.jrsv-avatar').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var b = this;
      ensure(function () { if (S.anon) { login(null, ACCOUNT, 'account'); return; } paintMenu(); toggleSurface(b, acct.querySelector('.jrsv-menu')); });
    }, false);
    // Popover tabs + close behaviour
    saved.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('.jrsv-tab') : null;
      if (!t) return;
      e.preventDefault(); e.stopPropagation();
      saved.setAttribute('data-tab', t.getAttribute('data-tab')); paintPop();
    }, false);
    document.addEventListener('click', function (e) {
      if (!openSurface) return;
      if (!e.target.closest || !e.target.closest('.jrsv-item')) closeSurfaces();
    }, false);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openSurface) closeSurfaces(); }, false);
  }
  function popEmpty(kind) {
    if (kind === 'searches') return '<div class="jrsv-pop__empty"><span class="jrsv-eico">' + ICO.search + '</span><p><strong>No saved searches</strong>Run a search, then tap Save Search to get new matches by email.</p></div>';
    return '<div class="jrsv-pop__empty"><span class="jrsv-eico">' + ICO.heart + '</span><p><strong>No saved homes yet</strong>Tap the heart on any listing and it will be waiting here.</p></div>';
  }
  function paintPop() {
    var li = document.querySelector('.jrsv-item--saved'); if (!li) return;
    var pop = li.querySelector('.jrsv-pop'); if (!pop) return;
    var tab = li.getAttribute('data-tab') || 'homes';
    var body;
    if (tab === 'searches') {
      body = S.searches.length ? S.searches.slice(0, 4).map(function (x) {
        return '<a class="jrsv-li" href="' + SEARCH + '?' + esc(x.query) + '"><span class="jrsv-li__th jrsv-li__th--ico">' + ICO.search + '</span><span class="jrsv-li__m"><span class="jrsv-li__p">' + esc(x.name) + '</span><span class="jrsv-li__a">' + esc(qSummary(x.query).join(' · ')) + ' · alerts ' + esc(x.freq || 'daily') + '</span></span><span class="jrsv-li__chev">' + ICO.chev + '</span></a>';
      }).join('') : popEmpty('searches');
    } else {
      body = S.homes.length ? S.homes.slice(0, 4).map(function (h) {
        return '<a class="jrsv-li" href="' + esc(h.url || ACCOUNT + '#homes') + '"' + (h.url ? ' target="_blank" rel="noopener"' : '') + '>' + (h.image ? '<img class="jrsv-li__th" src="' + esc(h.image) + '" alt="" loading="lazy">' : '<span class="jrsv-li__th jrsv-li__th--ico">' + ICO.home + '</span>') + '<span class="jrsv-li__m"><span class="jrsv-li__p">' + esc(h.price || '') + '</span><span class="jrsv-li__a">' + esc(h.address || h.mls) + '</span></span><span class="jrsv-li__chev">' + ICO.chev + '</span></a>';
      }).join('') : popEmpty('homes');
    }
    pop.innerHTML = '<div class="jrsv-pop__hd"><h3>Saved</h3><a class="jrsv-pop__all" href="' + ACCOUNT + '#' + tab + '">View all</a></div>'
      + '<div class="jrsv-tabs" role="tablist"><button type="button" class="jrsv-tab' + (tab === 'homes' ? ' is-on' : '') + '" data-tab="homes" role="tab">Homes<b>' + S.homes.length + '</b></button><button type="button" class="jrsv-tab' + (tab === 'searches' ? ' is-on' : '') + '" data-tab="searches" role="tab">Searches<b>' + S.searches.length + '</b></button></div>'
      + '<div class="jrsv-pop__bd">' + body + '</div>'
      + '<div class="jrsv-pop__ft"><a class="jra-btn jra-btn--ghost jra-btn--block" href="' + SEARCH + '">' + ICO.search + 'Search homes</a></div>';
  }
  function menuItems(cls) {
    var p = S.profile || {};
    return '<a class="' + cls + '" href="' + ACCOUNT + '#homes">' + ICO.heart + '<span>Saved homes</span>' + (S.homes.length ? '<b class="jrsv-n">' + S.homes.length + '</b>' : '') + '</a>'
      + '<a class="' + cls + '" href="' + ACCOUNT + '#searches">' + ICO.search + '<span>Saved searches</span>' + (S.searches.length ? '<b class="jrsv-n">' + S.searches.length + '</b>' : '') + '</a>'
      + '<a class="' + cls + '" href="' + ACCOUNT + '#hidden">' + ICO.hide + '<span>Hidden homes</span></a>'
      + '<a class="' + cls + '" href="' + ACCOUNT + '#alerts">' + ICO.bell + '<span>Notifications</span></a>'
      + '<a class="' + cls + '" href="' + ACCOUNT + '#profile">' + ICO.user + '<span>Edit profile</span></a>';
  }
  function paintMenu() {
    var li = document.querySelector('.jrsv-item--acct'); if (!li) return;
    var m = li.querySelector('.jrsv-menu'); if (!m) return;
    var p = S.profile || {};
    m.innerHTML = '<div class="jrsv-menu__who"><span class="jrsv-menu__av">' + esc(initials()) + '</span><div><div class="jrsv-menu__nm">' + esc(p.name || 'Your account') + '</div><div class="jrsv-menu__ty">' + esc(p.userType || 'Home Buyer') + (p.location ? ' · ' + esc(p.location) : '') + '</div></div></div>'
      + '<div class="jrsv-menu__ls">' + menuItems('jrsv-menu__it')
      + '<a class="jrsv-menu__it jrsv-menu__it--out" href="/account/logout">' + ICO.out + '<span>Sign out</span></a></div>';
  }

  /* ---------- header: mobile bar heart + drawer block ---------- */
  function buildMobile() {
    var acts = document.querySelector('.gh-mobile-actions');
    if (acts && !acts.querySelector('.gh-mobile-action--saved')) {
      var a = el('<a class="gh-mobile-action gh-mobile-action--saved" href="' + ACCOUNT + '#homes" aria-label="Saved homes">' + ICO.heart + '<span class="jrsv-count"></span></a>');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        ensure(function () { if (S.anon) { login(null, ACCOUNT + '#homes', 'account'); return; } location.href = ACCOUNT + '#homes'; });
      }, false);
      acts.insertBefore(a, acts.firstChild);
    }
    var nav = document.querySelector('#ghNav');
    if (nav && !nav.querySelector('.jrsv-mob')) {
      var li = el('<li class="jrsv-mob" data-jrsv-mob></li>');
      nav.insertBefore(li, nav.firstChild);
      li.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-mob]') : null;
        if (!t) return;
        e.preventDefault();
        var k = t.getAttribute('data-mob');
        ensure(function () { if (S.anon) { login(null, k === 'saved' ? ACCOUNT + '#homes' : ACCOUNT, 'account'); return; } location.href = k === 'saved' ? ACCOUNT + '#homes' : ACCOUNT; });
      }, false);
    }
    paintMobile();
  }
  function paintMobile() {
    var li = document.querySelector('.jrsv-mob'); if (!li) return;
    var p = S.profile || {};
    if (S.anon) {
      li.innerHTML = '<div class="jrsv-mob__card"><div class="jrsv-mob__who"><span class="jrsv-mob__av jrsv-mob__av--out">' + ICO.user + '</span><div><div class="jrsv-mob__nm">Sign in or create an account</div><div class="jrsv-mob__ty">Save homes, searches and get alerts. Free.</div></div></div>'
        + '<div class="jrsv-mob__acts"><button type="button" class="jra-btn" data-mob="account">Sign in</button><button type="button" class="jra-btn jra-btn--ghost" data-mob="saved">' + ICO.heart + 'Saved</button></div></div>';
    } else {
      li.innerHTML = '<div class="jrsv-mob__card"><div class="jrsv-mob__who"><span class="jrsv-mob__av">' + esc(initials()) + '</span><div><div class="jrsv-mob__nm">' + esc(p.name || 'Your account') + '</div><div class="jrsv-mob__ty">' + esc(p.userType || 'Home Buyer') + '</div></div></div>'
        + '<div class="jrsv-mob__grid">'
        + '<a class="jrsv-mob__q" href="' + ACCOUNT + '#homes">' + ICO.heart + 'Saved homes' + (S.homes.length ? '<b>' + S.homes.length + '</b>' : '') + '</a>'
        + '<a class="jrsv-mob__q" href="' + ACCOUNT + '#searches">' + ICO.search + 'Searches' + (S.searches.length ? '<b>' + S.searches.length + '</b>' : '') + '</a>'
        + '<a class="jrsv-mob__q" href="' + ACCOUNT + '#alerts">' + ICO.bell + 'Alerts</a>'
        + '<a class="jrsv-mob__q" href="' + ACCOUNT + '#profile">' + ICO.user + 'Profile</a>'
        + '</div><a class="jrsv-mob__out" href="/account/logout">Sign out</a></div>';
    }
  }

  /* ---------- paint all header state ---------- */
  function paint() {
    var n = S.anon ? 0 : S.homes.length + S.searches.length;
    var sv = document.querySelector('.jrsv-item--saved');
    if (sv) {
      var c = sv.querySelector('.jrsv-count');
      if (c) { c.textContent = n > 99 ? '99+' : n; c.className = 'jrsv-count' + (n ? ' on' : ''); }
      sv.classList.toggle('is-on', !!n);
      var lk = sv.querySelector('.jrsv-link'); if (lk) lk.setAttribute('aria-label', n ? 'Saved (' + n + ')' : 'Saved homes and searches');
    }
    var ac = document.querySelector('.jrsv-item--acct');
    if (ac) {
      ac.classList.toggle('is-in', !S.anon);
      var av = ac.querySelector('.jrsv-avatar'); if (av) { av.textContent = initials(); av.setAttribute('aria-label', 'Your account, ' + firstName()); }
      var lab = ac.querySelector('.jrsv-label'); if (lab) lab.textContent = 'Sign in';
      if (S.anon) closeSurfaces();
    }
    var mb = document.querySelector('.gh-mobile-action--saved');
    if (mb) { var mc = mb.querySelector('.jrsv-count'); if (mc) { mc.textContent = n > 99 ? '99+' : n; mc.className = 'jrsv-count' + (n ? ' on' : ''); } mb.classList.toggle('is-on', !!n); }
    paintMobile();
    if (openSurface) { paintPop(); paintMenu(); }
    paintFavs();
  }

  /* ---------- listing card hearts ---------- */
  function cardData(card) {
    var url = card.getAttribute('data-card-url') || '';
    var m = url.match(/\/property\/\d+-([A-Za-z0-9]+)-/);
    if (!m) return null;
    var media = card.querySelector('.jhps__card-media');
    var img = card.querySelector('img');
    var price = card.querySelector('.jhps__price');
    var addr = (media && media.getAttribute('aria-label') || '').replace(/^View\s+/i, '');
    if (!addr && img) addr = img.getAttribute('alt') || '';
    var sp = card.querySelectorAll('.jhps__spec');
    var beds = '', baths = '', sqft = '';
    for (var i = 0; i < sp.length; i++) {
      var t = (sp[i].textContent || '').trim();
      if (/bed/i.test(t) && !beds) beds = t.replace(/[^0-9.]/g, '');
      else if (/bath/i.test(t) && !baths) baths = t.replace(/[^0-9.]/g, '');
      else if (/sq/i.test(t) && !sqft) sqft = t.replace(/[^0-9]/g, '');
    }
    return { mls: m[1], url: url, address: addr, price: price ? (price.textContent || '').trim() : '', image: img ? img.getAttribute('src') || '' : '', beds: beds, baths: baths, sqft: sqft };
  }
  function paintFavs() {
    var hset = {};
    if (!S.anon && S.hidden && S.hidden.length) S.hidden.forEach(function (x) { hset[x.mls] = 1; });
    [].forEach.call(document.querySelectorAll('.jrsv-fav[data-mls]'), function (b) {
      var cc = b.closest('article');
      if (cc && hset[b.getAttribute('data-mls')]) { cc.parentNode && cc.parentNode.removeChild(cc); return; }
      var on = !S.anon && isSaved(b.getAttribute('data-mls'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from saved homes' : 'Save this home');
      b.setAttribute('title', on ? 'Saved' : 'Save this home');
    });
  }
  function beat(b) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); }
  function buildFavs() {
    [].forEach.call(document.querySelectorAll('article.jhps__card'), function (card) {
      var media = card.querySelector('.jhps__card-media'); if (!media) return;
      if (media.querySelector('.jrsv-fav')) return;
      var d = cardData(card); if (!d) return;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      var b = el('<button type="button" class="jrsv-fav" data-mls="' + esc(d.mls) + '">' + ICO.heart + '</button>');
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); beat(b);
        ensure(function () { if (S.anon) { login({ t: 'home', d: d }); return; } saveHome(d); });
      }, false);
      media.appendChild(b);
      var hb = el('<button type="button" class="jrsv-hide" data-mls="' + esc(d.mls) + '" aria-label="Hide this home" title="Hide this home"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button>');
      hb.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        ensure(function () {
          if (S.anon) { login({ t: 'hide', d: d }); return; }
          hideHome(d).then(function () { var c = hb.closest('article'); if (c && c.parentNode) c.parentNode.removeChild(c); toast('Hidden from your results', 'Manage', ACCOUNT + '#hidden'); });
        });
      }, false);
      media.appendChild(hb);
    });
    paintFavs();
  }

  /* ---------- save search (results page) ---------- */
  function currentQuery() { var p = new URLSearchParams(location.search); p.delete('view'); p.delete('page'); p.delete('_'); return p.toString(); }
  function defaultName() { var p = new URLSearchParams(location.search); var where = p.get('cities') || p.get('q') || 'Calgary'; return String(where).replace(/,\s*AB$/i, '') + ' homes'; }
  function buildSaveSearch() {
    if (!/\/pages\/property-search/.test(location.pathname)) return;
    if (document.querySelector('.jrsv-savebar')) return;
    var host = null, hs = ['.jhps__result-meta', '.jhps__resultshead', '.jhps__count', '.jps-results-head', '.jhps__toolbar'];
    for (var hi = 0; hi < hs.length; hi++) { var hn = document.querySelector(hs[hi]); if (hn && hn.getBoundingClientRect().height > 0) { host = hn; break; } }
    if (!host) { var c = document.querySelector('article.jhps__card'); host = c && c.parentNode ? c.parentNode.parentNode : null; }
    if (!host) return;
    var wrap = el('<span class="jrsv-savebar"><button type="button" class="jra-btn jra-btn--sm">' + ICO.bell + 'Save search</button></span>');
    wrap.querySelector('button').addEventListener('click', function (e) {
      e.preventDefault();
      var payload = { name: defaultName(), query: currentQuery(), freq: 'daily', alerts: true };
      ensure(function () { if (S.anon) { login({ t: 'search', d: payload }); return; } saveSearch(payload); });
    }, false);
    var nx = host.querySelector('.jhps__next-link');
    if (nx) { wrap.style.marginLeft = 'auto'; host.insertBefore(wrap, nx); }
    else if (host.firstChild) host.insertBefore(wrap, host.firstChild);
    else host.appendChild(wrap);
  }

  /* ---------- dashboard (/pages/my-account; shell is server-rendered) ---------- */
  var NAV = ['homes', 'searches', 'hidden', 'alerts', 'profile'];
  var PREFS = [
    ['new_home_alerts', 'New home alerts', 'New listings that match your saved searches'],
    ['home_status_updates', 'Home status updates', 'Price changes, open houses and status changes on your saved homes'],
    ['weekender', 'The Weekender', 'A weekly email of new listings, open houses and Calgary market insight'],
    ['saved_home_reminder', 'Saved home reminder', 'A periodic reminder of the homes you have saved'],
    ['market_intel', 'Market Intel', 'Occasional Calgary market updates and buying or selling guidance']
  ];
  var TITLES = { profile: 'Edit profile', searches: 'Saved searches', homes: 'Saved homes', hidden: 'Hidden homes', alerts: 'Notifications' };
  var LEDES = {
    profile: 'A few details so Jasjeet can help properly. Your sign-in email and security are managed on your secure account page.',
    searches: 'Jasjeet keeps an eye on these for you: new listings, price drops and open houses in the areas you are watching.',
    homes: 'Every home you have hearted, on every device you sign in from.',
    hidden: 'Listings you have hidden stay out of your search results. Unhide any of them here.',
    alerts: 'Choose what you hear about, and how often.'
  };
  function dashSection() { var h = (location.hash || '').replace('#', ''); return NAV.indexOf(h) > -1 ? h : 'homes'; }
  function emptyBlock(ico, t, p, cta, href) {
    return '<div class="jra-empty"><span class="jra-empty__ico">' + ico + '</span><h3>' + esc(t) + '</h3><p>' + esc(p) + '</p><a class="jra-btn" href="' + esc(href || SEARCH) + '">' + ICO.search + esc(cta || 'Search homes') + '</a></div>';
  }
  function homesHtml() {
    if (!S.homes.length) return emptyBlock(ICO.heart, 'No saved homes yet', 'Tap the heart on any listing and it will be waiting here, on every device you sign in from.');
    return '<div class="jra-grid">' + S.homes.map(function (h) {
      return '<article class="jra-card">'
        + '<a class="jra-card__media" href="' + esc(h.url || '#') + '" target="_blank" rel="noopener">' + (h.image ? '<img src="' + esc(h.image) + '" alt="" loading="lazy">' : '') + '</a>'
        + '<button type="button" class="jrsv-fav is-on" data-act="rmHome" data-id="' + esc(h.mls) + '" aria-label="Remove from saved homes" title="Remove">' + ICO.heart + '</button>'
        + '<div class="jra-card__bd"><div class="jra-card__p">' + esc(h.price || '') + '</div><div class="jra-card__a">' + esc(h.address || h.mls) + '</div>'
        + '<div class="jra-card__s">' + specs(h) + '</div>'
        + '<div class="jra-card__ft"><span class="jra-card__mls">MLS® ' + esc(h.mls) + '</span>' + (h.url ? '<a class="jra-btn jra-btn--sm jra-btn--soft" href="' + esc(h.url) + '" target="_blank" rel="noopener">View</a>' : '') + '</div></div></article>';
    }).join('') + '</div>';
  }
  function searchesHtml() {
    if (!S.searches.length) return emptyBlock(ICO.search, 'No saved searches yet', 'Run a search, then tap Save search on the results and new matches come to you by email.', 'Start a search');
    return '<div class="jra-list">' + S.searches.map(function (x) {
      var f = x.freq || 'daily';
      var seg = ['instant', 'daily', 'weekly', 'off'].map(function (o) { return '<button type="button" class="' + (o === f ? 'is-on' : '') + '" data-freq="' + esc(x.id) + '" data-val="' + o + '">' + (o === 'off' ? 'Off' : o.charAt(0).toUpperCase() + o.slice(1)) + '</button>'; }).join('');
      return '<div class="jra-srch"><div><div class="jra-srch__nm">' + esc(x.name) + '</div>'
        + '<div class="jra-chips">' + qSummary(x.query).map(function (c) { return '<span class="jra-chip">' + esc(c) + '</span>'; }).join('') + '</div>'
        + '<div class="jra-srch__alerts"><span>Email alerts</span><span class="jra-seg">' + seg + '</span></div></div>'
        + '<div class="jra-srch__acts"><a class="jra-btn jra-btn--sm" href="' + SEARCH + '?' + esc(x.query) + '">Run search</a><button type="button" class="jra-btn jra-btn--sm jra-btn--ghost" data-act="rmSearch" data-id="' + esc(x.id) + '">Remove</button></div></div>';
    }).join('') + '</div>';
  }
  function hiddenHtml() {
    if (!S.hidden.length) return emptyBlock(ICO.hide, 'Nothing hidden', 'Use the × on any listing to keep it out of your results. It will be kept here in case you change your mind.');
    return S.hidden.map(function (x) {
      return '<div class="jra-row">' + (x.image ? '<img class="jra-row__th" src="' + esc(x.image) + '" alt="" loading="lazy">' : '<div class="jra-row__th"></div>')
        + '<div class="jra-row__m"><div class="jra-row__p">' + esc(x.price || '') + '</div><div class="jra-row__a">' + esc(x.address || x.mls) + '</div><div class="jra-row__s">MLS® ' + esc(x.mls) + '</div></div>'
        + '<button type="button" class="jra-btn jra-btn--sm jra-btn--ghost" data-act="unhide" data-id="' + esc(x.mls) + '">Unhide</button></div>';
    }).join('');
  }
  function prefsHtml() {
    return PREFS.map(function (p) {
      var on = S.prefs[p[0]] !== false;
      return '<div class="jra-pref"><div><h3>' + esc(p[1]) + '</h3><p>' + esc(p[2]) + '</p></div><button type="button" class="jra-sw" role="switch" aria-checked="' + (on ? 'true' : 'false') + '" data-pref="' + p[0] + '" aria-label="' + esc(p[1]) + '"></button></div>';
    }).join('') + '<button type="button" class="jra-unsub" data-act="unsuball">Turn off all notifications</button>'
      + '<p class="jra-note">Preferences are stored with your account and apply to every device you sign in from.</p>';
  }
  function profileHtml() {
    var p = S.profile || {};
    var types = ['Home Buyer', 'Home Seller', 'Buyer & Seller', 'Investor', 'Just Looking'];
    var sel = types.map(function (t) { return '<option value="' + esc(t) + '"' + (p.userType === t ? ' selected' : '') + '>' + esc(t) + '</option>'; }).join('');
    return '<div class="jra-form">'
      + '<div class="jra-ro"><div><strong>Email</strong><span>Managed by your sign-in</span></div><a href="https://account.jasjeetsingh.ca" target="_blank" rel="noopener">Manage</a></div>'
      + '<div class="jra-ro"><div><strong>Sign-in &amp; security</strong><span>One-time email code</span></div><a href="https://account.jasjeetsingh.ca" target="_blank" rel="noopener">Manage</a></div>'
      + '<div style="height:12px"></div>'
      + '<div class="jra-f2"><div class="jra-fld"><label for="jrsvName">Full name</label><input id="jrsvName" type="text" value="' + esc(p.name || '') + '" placeholder="Your name" autocomplete="name"></div>'
      + '<div class="jra-fld"><label for="jrsvPhone">Phone</label><input id="jrsvPhone" type="tel" value="' + esc(p.phone || '') + '" placeholder="(403) 000-0000" autocomplete="tel"></div></div>'
      + '<div class="jra-f2"><div class="jra-fld"><label for="jrsvType">I am a</label><select id="jrsvType">' + sel + '</select></div>'
      + '<div class="jra-fld"><label for="jrsvLoc">Area of interest</label><input id="jrsvLoc" type="text" value="' + esc(p.location || '') + '" placeholder="Calgary, AB"></div></div>'
      + '<button type="button" class="jra-btn" data-act="saveProfile">Save profile</button>'
      + '<p class="jra-note">Telling Jasjeet what you are looking for means the homes and alerts you get are actually relevant.</p></div>';
  }
  function panelHtml(sec) {
    if (sec === 'homes') return homesHtml();
    if (sec === 'searches') return searchesHtml();
    if (sec === 'hidden') return hiddenHtml();
    if (sec === 'alerts') return prefsHtml();
    return profileHtml();
  }
  function setPref(k, on) { var b = {}; b[k] = on; S.prefs[k] = on; post('/prefs', b); }
  function saveProfile() {
    var g = function (id) { var e = document.getElementById(id); return e ? e.value : ''; };
    var p = { name: g('jrsvName'), phone: g('jrsvPhone'), userType: g('jrsvType'), location: g('jrsvLoc') };
    post('/profile', p).then(function (d) {
      if (d && d.ok) { S.profile = d.profile; toast('Profile saved'); paint(); renderDash(); track('profile_updated', { userType: p.userType, location: p.location }); }
      else toast('Could not save that');
    });
  }
  function renderDash() {
    var acc = document.getElementById('jrsv-acc');
    if (!acc) return;
    if (S.ready) acc.setAttribute('data-auth', S.anon ? 'out' : 'in');
    var pn = document.getElementById('jrsv-panel');
    if (S.ready && S.anon) { if (pn) { pn.innerHTML = ''; pn.removeAttribute('aria-busy'); } return; }
    var sec = dashSection();
    acc.setAttribute('data-sec', sec);
    var ti = acc.querySelector('[data-jrsv-title]'); if (ti) ti.textContent = TITLES[sec];
    var le = acc.querySelector('[data-jrsv-lede]'); if (le) le.textContent = LEDES[sec];
    [].forEach.call(acc.querySelectorAll('[data-nav]'), function (a) {
      var on = a.getAttribute('data-nav') === sec;
      a.classList.toggle('is-on', on);
      if (on) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
    });
    var pr = S.profile || {};
    var nn = acc.querySelector('[data-jrsv-name]'); if (nn && (pr.name || !nn.textContent.trim())) nn.textContent = pr.name || 'Your account';
    var ty = acc.querySelector('[data-jrsv-type]'); if (ty && (pr.userType || !ty.textContent.trim())) ty.textContent = pr.userType || 'Home Buyer';
    var av = acc.querySelector('[data-jrsv-av]'); if (av) av.textContent = initials();
    var counts = { homes: S.homes.length, searches: S.searches.length, hidden: S.hidden.length };
    [].forEach.call(acc.querySelectorAll('[data-jrsv-count]'), function (c) { var k = c.getAttribute('data-jrsv-count'); var v = counts[k] || 0; c.textContent = v; if (c.classList.contains('jra-n')) c.style.display = v ? '' : 'none'; });
    if (!S.ready || !pn) return;
    pn.innerHTML = panelHtml(sec);
    pn.removeAttribute('aria-busy');
  }
  function hydrateDashboard() {
    var acc = document.getElementById('jrsv-acc');
    if (!acc || acc.getAttribute('data-bound') === '1') return;
    acc.setAttribute('data-bound', '1');
    window.addEventListener('hashchange', renderDash, false);
    acc.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-act],[data-pref],[data-freq]') : null;
      if (!t) return;
      if (t.hasAttribute('data-pref')) {
        e.preventDefault();
        var on = t.getAttribute('aria-checked') !== 'true';
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        setPref(t.getAttribute('data-pref'), on); return;
      }
      if (t.hasAttribute('data-freq')) {
        e.preventDefault();
        var id = t.getAttribute('data-freq'), val = t.getAttribute('data-val'), cur = null;
        for (var i = 0; i < S.searches.length; i++) if (S.searches[i].id === id) cur = S.searches[i];
        if (cur) saveSearch({ id: id, name: cur.name, query: cur.query, freq: val, alerts: val !== 'off' }).then(renderDash);
        return;
      }
      var act = t.getAttribute('data-act'), id2 = t.getAttribute('data-id');
      e.preventDefault();
      if (act === 'rmHome') { var card = t.closest('.jra-card'); if (card) { card.style.transition = 'opacity .25s,transform .25s'; card.style.opacity = '0'; card.style.transform = 'scale(.96)'; } delHome(id2).then(function () { renderDash(); toast('Removed from saved homes'); }); }
      else if (act === 'rmSearch') delSearch(id2).then(function () { renderDash(); toast('Search removed'); });
      else if (act === 'unhide') api('/hidden?mls=' + encodeURIComponent(id2), { method: 'DELETE' }).then(function () { load().then(function () { toast('Back in your results'); }); });
      else if (act === 'saveProfile') saveProfile();
      else if (act === 'unsuball') { PREFS.forEach(function (p) { S.prefs[p[0]] = false; }); post('/prefs', { all: false }); renderDash(); toast('All notifications turned off'); }
    }, false);
    renderDash();
  }

  /* ---------- init ---------- */
  var booted = false;
  function clearAuthState() {
    S.ready = false; S.anon = true;
    S.homes = []; S.searches = []; S.hidden = []; S.prefs = {}; S.profile = {};
    try { sessionStorage.removeItem('jrsv_intent'); } catch (e) {}
    var acc = document.getElementById('jrsv-acc'); if (acc) acc.setAttribute('data-auth', 'out');
    var pn = document.getElementById('jrsv-panel'); if (pn) { pn.innerHTML = ''; pn.removeAttribute('aria-busy'); }
    closeSurfaces(); paint();
  }
  var authBusy = false, authAt = 0;
  function refreshAuth(force) {
    var now = Date.now();
    if (authBusy || (!force && now - authAt < 2000)) return;
    authBusy = true; authAt = now;
    load().then(function () { authBusy = false; }, function () { authBusy = false; });
  }
  function boot() {
    cssReady(); buildHeader(); buildMobile(); buildFavs(); buildSaveSearch(); hydrateDashboard(); paint();
    if (booted) return;
    booted = true;
    refreshAuth(true);
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/account/logout"]') : null;
      if (a) { clearAuthState(); return; }
      var li = e.target && e.target.closest ? e.target.closest('a[href*="/account/login"],a[href*="/customer_authentication/login"]') : null;
      if (li && !li.closest('.jrsv-gate')) { e.preventDefault(); login(null, ACCOUNT, 'account'); }
    }, true);
    window.addEventListener('pagehide', function () { S.ready = false; }, false);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshAuth(true); }, false);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshAuth(false); }, false);
    var mo = new MutationObserver(function () { buildFavs(); buildSaveSearch(); });
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  window.JRSaved = { open: function (ctx) { login(null, ACCOUNT, ctx || 'account'); }, state: S };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  setTimeout(boot, 900); setTimeout(boot, 2500);
})();
